import React from "react"

import { Item, Scope } from "@ua/web-sdk/lib/remote-data/preference-center"
import { SubscriptionOperatorProps } from "./types"
import ChannelSubscriptionItem from "./items/ChannelSubscriptionItem"
import ContactSubscriptionItem from "./items/ContactSubscriptionItem"
import ContactSubscriptionGroupItem from "./items/ContactSubscriptionGroupItem"
import AlertItem from "./items/AlertItem"

export type Props = SubscriptionOperatorProps & {
  item: Item
}

const Item: React.FC<Props> = (props) => {
  const { item } = props
  const subscribe = React.useCallback(
    (listId: string, scope?: Scope) => {
      return props.onSubscriptionOperation("subscribe", listId, scope)
    },
    [props.onSubscriptionOperation]
  )

  const unsubscribe = React.useCallback(
    (listId: string, scope?: Scope) => {
      return props.onSubscriptionOperation("unsubscribe", listId, scope)
    },
    [props.onSubscriptionOperation]
  )

  const isSubscribed = React.useCallback(
    (listId: string, scope?: Scope): boolean => {
      if (scope) {
        return Boolean(
          props.subscriptions
            .find((list) => list.id === listId)
            ?.scopes?.includes(scope)
        )
      }
      return Boolean(props.subscriptions.find((list) => list.id === listId))
    },
    [props.subscriptions]
  )

  switch (item.type) {
    case "channel_subscription":
      return (
        <ChannelSubscriptionItem
          item={item}
          onSubscribe={subscribe}
          onUnsubscribe={unsubscribe}
          isSubscribed={isSubscribed}
        />
      )
    case "contact_subscription":
      return (
        <ContactSubscriptionItem
          item={item}
          onSubscribe={subscribe}
          onUnsubscribe={unsubscribe}
          isSubscribed={isSubscribed}
        />
      )
    case "contact_subscription_group":
      return (
        <ContactSubscriptionGroupItem
          item={item}
          onSubscribe={subscribe}
          onUnsubscribe={unsubscribe}
          isSubscribed={isSubscribed}
        />
      )
    case "alert":
      return (
        <AlertItem
          item={item}
          onSubscribe={subscribe}
          onUnsubscribe={unsubscribe}
          isSubscribed={isSubscribed}
        />
      )
    default:
      return <></>
  }
}

export default Item
